import { useApp, } from './useApp';

export function useAuth() {
    const { user, authIsReady, } = useApp();

    return {
        user,
        authIsReady,
    };
};